import styled from 'styled-components';
import { Text } from '@visx/text';

export const HeaderText = styled(Text)`
    dominant-baseline: central;
    text-anchor: start;
    font-size: 12px;
    fill: #868e96;
`;
